import styles from './MediaWrapper.scss';

import cx from 'classnames';
import { ReferencedEntry } from 'contentful';
import React from 'react';

import { Link, Subject } from 'src/api/contentful/contentTypes.cloverdotcom';
import { ContentLink } from 'src/components/ContentLink/ContentLink';
import { DisplayMode, EnhancedMedia } from 'src/components/EnhancedMedia/EnhancedMedia';
import { getField, isEntry } from 'src/utils/EntryUtil';

interface MediaWrapProps extends React.HTMLAttributes<HTMLDivElement> {
  entry?: ReferencedEntry<Subject>;
  link?: ReferencedEntry<Link>;
  enhancedMediaRef?: React.RefObject<EnhancedMedia>;
  handleMouseEnter?: () => void;
  handleMouseLeave?: () => void;
  imageCount?: number;
}

export const MediaWrapper: React.FC<MediaWrapProps> =
  ({ entry, link, className, enhancedMediaRef, handleMouseEnter, handleMouseLeave, imageCount, ...props }) => {

    if (!isEntry(entry)) return null;

    const video = getField(entry, 'video');

    return (
      <ContentLink
        hideTitle
        alwaysRenderChildren
        entry={link}
        className={cx(
          styles.mediaSection,
          { [styles.mediaSectionOneImage]: imageCount === 1 },
          { [styles.mediaSectionTwoImages]: imageCount === 2 },
          { [styles.mediaSectionThreeImages]: imageCount === 3 },
          { [styles.mediaSectionFourImages]: imageCount === 4 },
          className
          )}
      >
        <div
          className={styles.wrap}
          {...props}
        >
          <EnhancedMedia
            ref={enhancedMediaRef}
            autoPlay={false}
            muted
            loop
            entry={entry}
            className={styles.media}
            preferWidth
            disableFrame
            displayMode={DisplayMode.IMAGE_ONLY}
            onMouseEnter={video && handleMouseEnter}
            onMouseLeave={video && handleMouseLeave}
          />
        </div>
      </ContentLink>
    );
  };
